import React from 'react'
import { useMutation } from 'react-query'

import { authActionTypes, useAuthDispatch } from 'src/providers/AuthProviders'
import { putUpdateGlobalNotification } from 'src/services/put/putUpdateNotification'

import AccountPage from 'src/pages/menu/Account'

const actionTypeMap = {
  line_notifi: authActionTypes.CHANGE_OFFICIAL_NOTI,
  line_notify_story: authActionTypes.CHANGE_STORY_TALK_NOTI,
  line_notify_realtime: authActionTypes.CHANGE_REAL_TALK_NOTI,
  line_follow_story: authActionTypes.CHANGE_STORY_TALK_FOLLOW,
  line_follow_realtime: authActionTypes.CHANGE_REAL_TALK_FOLLOW
}

const AccountPageContainer = () => {
  const authDispatch = useAuthDispatch()

  const { mutate: toggleGlobalSetting } = useMutation({
    mutationFn: async (isNotification) => {
      await putUpdateGlobalNotification(isNotification)
    },
    onSuccess: (_data, setting) => {
      const [key, value] = Object.entries(setting)[0]
      const type = actionTypeMap[key]

      authDispatch({ type, payload: value })
    }
  })

  return <AccountPage toggleGlobalSetting={toggleGlobalSetting} />
}

export default AccountPageContainer
